
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/videos",
      function () {
        return require("private-next-pages/support/videos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/videos"])
      });
    }
  